import { Action } from '@ngrx/store';

export const SELECT_DEEP_LINK_PRODUCT = 'SELECT_DEEP_LINK_PRODUCT';

export class SelectDeepLinkProduct implements Action {
  type = SELECT_DEEP_LINK_PRODUCT;

  constructor(public payload?: any) {}
}

export type Actions = SelectDeepLinkProduct;
